if (!customElements.get('mobile-sticky-bar')) {
  customElements.define(
    'mobile-sticky-bar',

    class MobileStickyBar extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        document.body.classList.add('mobile-sticky-bar-enabled');
        this.lastScrollTop = 0;
        this.scrollHandler = FoxTheme.utils.debounce(this.onScrollHandler.bind(this), 10);
        this.init();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.scrollHandler);
      }

      init() {
        this.calculateHeight();
        window.addEventListener('scroll', this.scrollHandler, false);
      }

      calculateHeight() {
        requestAnimationFrame(() => {
          document.documentElement.style.setProperty('--mobile-sticky-bar-height', `${this.offsetHeight}px`);
        });
      }

      onScrollHandler() {
        const scrollTop = window.scrollY;

        requestAnimationFrame(() => {
          const mobileNavStatic = document.getElementById('mobileNavStatic');
          const offsetTop = mobileNavStatic ? mobileNavStatic.offsetTop : 0;
          const pointTouch = offsetTop - scrollTop - window.innerHeight;

          if (scrollTop > this.lastScrollTop) {
            this.scrollDirection = 'down';
          } else {
            this.scrollDirection = 'up';
          }

          this.lastScrollTop = scrollTop;

          if (this.scrollDirection == 'up' && pointTouch > 0) {
            this.classList.remove('up');
            this.classList.add('down');
            document.body.classList.remove('mobile-sticky-bar-up');
            document.body.classList.add('mobile-sticky-bar-down');
          } else {
            this.classList.add('up');
            this.classList.remove('down');
            document.body.classList.remove('mobile-sticky-bar-down');
            document.body.classList.add('mobile-sticky-bar-up');
          }
        });
      }
    }
  );
}
